
export default {
  name: 'SghLoading',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
}
